(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("app/index", [], factory);
	else if(typeof exports === 'object')
		exports["Gameday"] = factory();
	else
		root["Gameday"] = factory();
})(this, () => {
return 